export const LEGAL_ENTITY = {
  tradeName: 'CENDOSCAR',
  legalName: 'CENTRO DIAGNÓSTICO DE ENDOSCOPÍA, CARDIOLOGÍA Y DIGESTIVO CENDOSCAR SRL',
  rnc: '132-38830-5',
  email: 'contacto@cendoscar.com',
  website: 'https://cendoscar.com',
  country: 'República Dominicana',
  updatedAt: '17 de julio de 2026',
} as const

export const LEGAL_ROUTES = {
  privacy: '/politica-de-privacidad',
  terms: '/terminos-y-condiciones',
  deletion: '/eliminacion-de-datos',
} as const

export const LEGAL_PAGE_METADATA: Record<string, { title: string; description: string }> = {
  'privacy-policy': { title: 'Política de Privacidad', description: 'Conoce cómo CENDOSCAR recopila, utiliza, protege, conserva y elimina la información relacionada con sus servicios digitales e integraciones con Meta.' },
  'terms-conditions': { title: 'Términos y Condiciones', description: 'Consulta las condiciones de uso del portal, las solicitudes de citas, los contenidos médicos y los servicios digitales de CENDOSCAR.' },
  'data-deletion': { title: 'Eliminación de Datos', description: 'Consulta cómo solicitar la eliminación de información asociada a CENDOSCAR y sus integraciones con Facebook, Instagram y Meta.' },
}
